<template>
  <div
    class="inputbox"
    :class="[
      (focus || focusOverwrite) ? 'focus' : '',
      size,
      type == 'date' ? 'text' : type,
      orientation,
      !valid && (showValid || intakeValidate) ? 'error' : '',
    ]"
  >
    <div
      @click="toggleTooltip()"
      v-if="!valid && (showValid || intakeValidate)"
      class="input-info"
    >
      <awesomeIcon icon="question-circle" />
    </div>

    <div
      v-if="tooltip && !valid && (showValid || intakeValidate)"
      class="input-tooltip"
    >
      {{ tooltipText }}
    </div>
    <label
      :class="['label', !valid && (showValid || intakeValidate) ? 'error' : '']"
      v-if="
        type == 'text' ||
        type == 'date' ||
        type == 'number' ||
        type == 'money' ||
        type == 'year' ||
        type == 'percentage' ||
        type == 'feePercentage'
      "
    >
      {{ label }}
    </label>

    <CurrencyInput
      ref="input"
      v-if="type == 'money'"
      :options="money"
      type="text"
      :placeholder="placeholder"
      :value="tempValue"
      @update:value="tempValue = $event"
      :class="{ error: !valid && (showValid || intakeValidate) }"
      @focus="focus = true; $emit('clicked')"
      @blur="focus = false; maxValue(); $emit('blur')"
      :disabled="disabled"
      :readonly="readonly"
    />

    <CurrencyInput
      ref="input"
      v-if="type == 'percentage'"
      :options="percentage"
      type="text"
      :placeholder="placeholder"
      :value="tempValue"
      @update:value="tempValue = $event"
      :class="{ error: !valid && (showValid || intakeValidate) }"
      @focus="focus = true; $emit('clicked')"
      @blur="focus = false; maxValue(); $emit('blur')"
      :disabled="disabled"
      :readonly="readonly"
    />

    <CurrencyInput
      ref="input"
      v-if="type == 'feePercentage'"
      :options="feePercentage"
      type="text"
      :placeholder="placeholder"
      :value="tempValue"
      @update:value="tempValue = $event"
      :class="{ error: !valid && (showValid || intakeValidate) }"
      @focus="focus = true; $emit('clicked')"
      @blur="focus = false; maxValue(); $emit('blur')"
      :disabled="disabled"
      :readonly="readonly"
    />

    <input
      v-if="type == 'text'"
      type="text"
      :placeholder="placeholder"
      :value="modelValue"
      :class="{ error: !valid && (showValid || intakeValidate) }"
      ref="input"
      @input="update"
      @focus="focus = true; $emit('clicked')"
      @blur="focus = false; $emit('blur')"
      :disabled="disabled"
      :readonly="readonly"
    />

    <input
      v-if="type == 'date'"
      type="date"
      :placeholder="placeholder"
      :value="modelValue"
      @input="update"
      :class="{ error: !valid && (showValid || intakeValidate) }"
      ref="input"
      @focus="focus = true"
      :min="minDatetime ? minDatetime.toISOString().split('T')[0] : ''"
      :max="maxDatetime ? maxDatetime.toISOString().split('T')[0] : ''"
    />

    <input
      v-if="type == 'number'"
      type="number"
      onkeypress='return event.charCode >= 48 && event.charCode <= 57'
      :placeholder="placeholder"
      :value="modelValue"
      :class="{ error: !valid && (showValid || intakeValidate) }"
      ref="input"
      :min="min"
      :max="max"
      @input="update"
      @focus="focus = true"
      @blur="focus = false; maxValue(); $emit('blur')"
      :disabled="disabled"
      :readonly="readonly"
    />

    <template v-if="type == 'radio' || type == 'checkbox'">
      <div v-for="(option, index) in options" :key="index">
        <input
          ref="input"
          :type="type"
          :name="`custominput-${id}`"
          :id="`custominput-${id}-${option.value}`"
          :value="option.value"
          :checked="modelValue == option.value"
          @input="update"
          @focus="focus = true"
          @blur="focus = false"
        />
        <label :for="`custominput-${id}-${option.value}`">
          11<awesomeIcon icon="fa-regular fa-square" class="unchecked" />
          22<awesomeIcon icon="fa-solid fa-square-check" class="checked" />
          {{ option.label }}
        </label>
      </div>
    </template>

    <template v-if="type == 'yesno'">
      <div class="label">
        {{ label }}
      </div>
      <span v-if="hasDate && dateValue" class="time">
        {{ new Date(dateValue).toLocaleString() }}
      </span>
      <input
        ref="input"
        type="radio"
        :name="`custominput-yesno-${id}`"
        :id="`custominput-${id}-no`"
        :value="yesnoOptions[0].value"
        :checked="modelValue === yesnoOptions[0].value"
        @click="update"
        :disabled="disabled"
      />
      <label :for="`custominput-${id}-no`" tabindex="0">
        <awesomeIcon
          :icon="modelValue == yesnoOptions[0].value ? 'check-circle' : 'fa-regular fa-circle'"
        />
        {{ yesnoOptions[0].label }}
      </label>
      <input
        ref="input"
        type="radio"
        :name="`custominput-yesno-${id}`"
        :id="`custominput-${id}-yes`"
        :value="yesnoOptions[1].value"
        :checked="modelValue === yesnoOptions[1].value"
        @click="update"
      />
      <label :for="`custominput-${id}-yes`" tabindex="0">
        <awesomeIcon
          :icon="modelValue === yesnoOptions[1].value ? 'check-circle' : 'fa-regular fa-circle'"
        />
        {{ yesnoOptions[1].label }}
      </label>
    </template>

    <template v-if="type == 'yesno2'">
      <input
        ref="input"
        type="radio"
        :name="`custominput-yesno-${id}`"
        :id="`custominput-${id}-no`"
        value="No"
        :checked="modelValue == 'No'"
        @click="update"
      />
      <input
        ref="input"
        type="radio"
        :name="`custominput-yesno-${id}`"
        :id="`custominput-${id}-yes`"
        value="Yes"
        :checked="modelValue == 'Yes'"
        @click="update"
      />
      <label :for="`custominput-${id}-no`" v-if="modelValue === 'Yes'" tabindex="0">
        <awesomeIcon :icon="boxtype == 'radio' ? 'check-circle' : 'check-square'" />
        {{ label }}
        <span
          v-if="modelValue === 'Yes' && hasDate && dateValue"
          style="float: right"
          class="time"
        >
          {{ new Date(dateValue).toLocaleString() }}
        </span>
      </label>
      <label :for="`custominput-${id}-yes`" v-else>
        <awesomeIcon
          :icon="boxtype == 'radio' ? 'fa-regular fa-circle' : 'fa-regular fa-square'"
        />
        {{ label }}
      </label>
    </template>

    <template v-if="type == 'radio2' || type == 'checkbox2'">
      <input
        ref="input"
        :type="'radio'"
        :name="`custominput-${name}`"
        :id="`custominput-${id}-${option}`"
        :value="option"
        :checked="option == modelValue"
        @click="update"
      />
      <label :for="`custominput-${id}-${option}`" v-if="modelValue != option" tabindex="0">
        <awesomeIcon icon="fa-regular fa-circle" class="unchecked" /> {{ label }}
      </label>
      <label :for="`custominput-${id}-${option}`" v-else tabindex="0">
        <awesomeIcon icon="check-circle" class="checked" /> {{ label }}
      </label>
    </template>

    <template v-if="type == 'dropdown'">
      <div @focus="openClose(); focus = true" @click="openClose(); focus = true" tabindex="0">
        <span class="label">{{ label }} <awesomeIcon icon="caret-down" /></span>
        <input
          type="text"
          :value="
            find(options, { value: modelValue }) ?
            find(options, { value: modelValue }).label
            : modelValue
          "
          readonly="readonly"
          class="dropdown-display"
        />
      </div>
      <div
        class="bg" v-if="dropdownlist"
        @click="optionsSearch == '' ? (dropdownlist = false) : searchSubmit(); focus = false"
      ></div>
      <ul class="list-container" v-if="dropdownlist">
        <div class="search" v-if="options.length > 7">
          <input
            type="text"
            ref="search"
            v-model="optionsSearch"
            @keyup.enter="searchSubmit"
            placeholder="Zoeken..."
          />
        </div>
        <ul class="list" tabindex="-1">
          <li
            v-for="(option, index) in filteredOptions"
            :key="index"
            @keyup.enter="update(option.value); dropdownlist = false; focus = false"
            @click="update(option.value); dropdownlist = false; focus = false"
            tabindex="0"
          >
            {{ option.label }}
          </li>
        </ul>
        <div
          class="cancel"
          @keyup.enter="dropdownlist = false; tempValue = ''; focus = false"
          @blur="dropdownlist = false"
          @click="dropdownlist = false; tempValue = ''; focus = false"
          tabindex="0"
        >
          Annuleren
        </div>
      </ul>
    </template>

    <div v-if="type == 'slider'">
      <div class="slider-label" v-if="label">
        <span>{{ label }}</span>
        <span class="slider-value">
          <template v-if="unitType == 'percent'">
            <b>{{ extra }}</b>
          </template>
          <template v-if="unitType == 'money'">
            {{ name }}
            <input type="number" :value="modelValue" @input="update" />
          </template>
          <template v-if="unitType == 'date'">
            <input
              ref="input"
              type="number"
              :value="modelValue"
              style="width: 30px"
              @input="update"
            />
            {{ name }} ({{ today.getDate() }}-{{ today.getMonth() + 1 }}-{{
              today.getFullYear() + parseInt(modelValue)
            }})
          </template>
        </span>
      </div>
      <div
        class="slider-tooltip"
        v-if="focus"
        :style="{ left: (78.5 / max) * modelValue + 10 + '%' }"
      >
        <template v-if="unitType == 'money'">
          {{ name }} {{ modelValue }}
        </template>
        <template v-if="unitType == 'date' || unitType == 'percent'">
          {{ modelValue }} {{ name }}
        </template>
      </div>
      <div class="min">
        <template v-if="unitType == 'money'">{{ name }} {{ min }}</template>
        <template v-if="unitType == 'date' || unitType == 'percent'">
          {{ min }} {{ name }}
        </template>
      </div>
      <div class="max">
        <template v-if="unitType == 'money'">
          {{ name }} {{ formatPrice(Number(max), false, 0) }}
        </template>
        <template v-if="unitType == 'date' || unitType == 'percent'">
          {{ max }} {{ name }}
        </template>
      </div>
      <input
        type="range"
        :min="min"
        :max="max"
        :value="modelValue"
        :step="step"
        @input="update"
        @focus="focus = true"
        @blur="focus = false"
      />
    </div>

    <template v-if="type == 'file'">
      <div class="file-row" v-for="file in localFiles" :key="file.path">
        <span v-if="showFiles && !showHoverInfo">
          {{file.path.substring(22 + prefix.length)}}
        </span>
        <p
          style="margin:0; cursor: help"
          class="concat150"
          v-else-if="showFiles && showHoverInfo"
          :title="file.path.substring(22 + prefix.length)"
        >
          <awesomeIcon icon="check"/>
          {{file.path.substring(22 + prefix.length)}}
        </p>
        <awesomeIcon v-else icon="check" />
        <a v-if="fileDelete" class="file-button" @click="remove(file.path)">
          Verwijder <awesomeIcon icon="times"/>
        </a>
        <a v-if="role > 8" class="file-button" @click="download(file.path)">
          Bekijken <awesomeIcon icon="eye"/>
        </a>
      </div>
      <div v-if="tooltip && !valid" class="input-tooltip">
        {{ tooltipText }}
      </div>
      <label
        v-if="!includes(validation, 'max') || max > localFiles.length"
        @drop="fileDropped"
        :for="`custominput-${id}-files`"
        class="file-dropzone"
        :class="[!valid ? 'error' : '', draggingFile ? 'expanded' : '']"
      >
        <awesomeIcon icon="upload"/>
        <span>{{ label ? label : 'Sleep uw bestanden hier of klik om te uploaden' }}</span>
      </label>
      <input
        ref="files"
        type="file"
        name="img"
        :id="`custominput-${id}-files`"
        multiple
        @change="uploadFiles($event.target.files)"
      />
    </template>

    <template v-if="type == 'addFile'">
      <input
        ref="files"
        type="file"
        name="img"
        :id="`custominput-${id}-files`"
        @change="uploadFiles($event.target.files)"
        hidden
      />
      <label :for="`custominput-${id}-files`">
        <awesomeIcon style="cursor: pointer;" icon="upload" />
      </label>
    </template>

  </div>
</template>

<script>
import {
  find, includes, filter, remove,
} from 'lodash-es';
import CurrencyInput from './currencyInput';

export default {
  name: 'CustomInput',
  components: { CurrencyInput },
  emits: ['clicked', 'changed', 'blur', 'focus', 'update:model-value', 'update:dateValue'],
  props: {
    align: String,
    size: String,
    extra: String,
    unitType: String,
    type: String,
    name: String,
    option: String,
    watch: String,
    label: String,
    placeholder: String,
    options: Array,
    validation: Array,
    focusOverwrite: {
      type: Boolean,
      default: false,
    },
    validationToggle: {
      type: Boolean,
      default: true,
    },
    showFiles: {
      type: Boolean,
      default: true,
    },
    prefix: String,
    completed: {
      type: Boolean,
      default: false,
    },
    modelValue: [String, Number],
    hasDate: Boolean,
    boxtype: {
      type: String,
      default: 'radio',
    },
    fromDate: {
      type: Date,
      default: null,
    },
    fileDelete: {
      type: Boolean,
      default: true,
    },
    showHoverInfo: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 1,
    },
    minDatetime: {
      type: Date,
      default: null,
    },
    max: {
      type: Number,
      default: 50,
    },
    level: {
      type: Number,
      default: 2,
    },
    maxDatetime: {
      type: Date,
      default: null,
    },
    step: {
      type: Number,
      default: 5,
    },
    dateValue: String,
    inputLabel: String,
    orientation: String,
    confirm: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    intakeId: {
      type: Number,
      default: null,
    },
    cb: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      id: this.$.uid,
      tempValue: null,
      optionsSearch: '',
      valid: true,
      showValid: false,
      focus: false,
      tooltip: false,
      tooltipText: '',
      dropdownlist: false,
      money: {
        formatStyle: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
        locale: 'nl-NL',
        precision: 0,
        hidePrefixOrSuffixOnFocus: false,
      },
      percentage: {
        formatStyle: 'percent',
        locale: 'nl-NL',
        precision: 2,
        hidePrefixOrSuffixOnFocus: false,
      },
      feePercentage: {
        formatStyle: 'percent',
        locale: 'nl-NL',
        precision: 5,
        hidePrefixOrSuffixOnFocus: false,
      },
      today: new Date(),
      selected: '',
      draggingFile: false,
    };
  },
  watch: {
    watch() {
      this.test();
    },
    min() {
      this.test();
    },
    max() {
      this.test();
    },
    modelValue() {
      this.test();
      this.$nextTick(() => {
        if (this.type === 'percentage') {
          if (Number(this.modelValue) / 100 !== Number(this.tempValue)) {
            this.tempValue = this.modelValue / 100;
          }
        } else if (this.type === 'date') {
          // if (typeof this.modelValue !== 'undefined') {
          //   this.tempValue = this.modelValue.slice(0, 10);
          // }
        } else {
          this.tempValue = this.modelValue;
        }
      });
    },
    tempValue() {
      if (this.type === 'percentage') {
        this.$emit('update:model-value', `${Math.round((this.tempValue || '') * 100)}`);
      } else if (this.type === 'date') {
        // if (
        //   new RegExp('^(19|20)(\\d{2})-(0?[1-9]|1[0-2])-(0?[1-9]|[12]\\d|30|31)')
        //     .test(this.tempValue)
        // ) {
        //   this.$emit(
        //     'update:model-value',
        //     new Date(`${this.tempValue}T12:00:00Z`).toISOString(),
        //   );
        //   this.valid = true;
        // } else if (this.tempValue === '') {
        //   this.$emit('update:model-value', this.tempValue);
        // }
      } else {
        this.$emit('update:model-value', this.tempValue);
      }
      this.$emit('changed');
    },
  },
  computed: {
    yesnoOptions() {
      if (Array.isArray(this.options)) {
        return this.options;
      }
      return [
        { label: 'Nee', value: 'No' },
        { label: 'Ja', value: 'Yes' },
      ];
    },
    intakeValidate() {
      return this.$store.state.intakeValidate;
    },
    filteredOptions() {
      return filter(
        this.options,
        (o) => o.label.toLowerCase().indexOf(this.optionsSearch.toLowerCase()) > -1,
      );
    },
    role() {
      return this.$store.state.role;
    },
    localFiles() {
      if (this.level === 3) {
        return filter(
          this.$parent.$parent.$parent.files,
          (o) => o.path.indexOf(this.prefix) > -1
          && new Date(Number(o.path.substr(7, 13))) > this.fromDate,
        );
      }
      return filter(
        this.$parent.$parent.files,
        (o) => o.path.indexOf(this.prefix) > -1
        && new Date(Number(o.path.substr(7, 13))) > this.fromDate,
      );
    },
  },
  created() {
    if (this.readonly) {
      this.percentage.hidePrefixOrSuffixOnFocus = false;
      this.percentage.hideGroupingSeparatorOnFocus = false;
      this.percentage.hideNegligibleDecimalDigitsOnFocus = false;
    }
    document.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.draggingFile = true;
    });
  },
  mounted() {
    if (this.type === 'percentage') {
      this.tempValue = this.modelValue / 100;
    } else if (this.type === 'date') {
      if (typeof this.modelValue !== 'undefined') {
        this.$emit('update:model-value', this.modelValue.slice(0, 10));
      }
    } else {
      this.tempValue = this.modelValue;
    }
    this.test(false);
    // eslint-disable-next-line
    this.$store.state.intake[this.id] = this.valid;
    if (this.type === 'dropdown') {
      if (find(this.options, { default: true })) {
        this.tempValue = find(this.options, { default: true }).value;
      }
    }
  },
  unmounted() {
    // eslint-disable-next-line
    delete this.$store.state.intake[this.id];
  },
  methods: {
    find,
    includes,
    fileDropped(e) {
      e.preventDefault();
      this.draggingFile = false;
      let files = [];

      if (e.dataTransfer.items) {
        for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
          if (e.dataTransfer.items[i].kind === 'file') {
            files.push(e.dataTransfer.items[i].getAsFile());
          }
        }
      } else {
        files = e.dataTransfer.files;
      }
      this.uploadFiles(files);
    },
    focusInput() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    maxValue() {
      const val = this.modelValue;
      if (this.validation && this.validation.includes('max') && Number(val) > this.max) {
        this.$emit('update:model-value', `${this.max}`);
      }
      if (this.validation && this.validation.includes('min') && Number(val) < this.min) {
        this.$emit('update:model-value', `${this.min}`);
      } else if (val === null) {
        this.$emit('update:model-value', '0');
      }
    },
    searchSubmit() {
      if (this.filteredOptions.length > 0) {
        this.update(this.filteredOptions[0].value);
        this.dropdownlist = false;
      }
    },
    openClose() {
      this.dropdownlist = !this.dropdownlist;
      this.$nextTick(() => {
        if (this.options.length > 7 && this.dropdownlist) {
          this.$refs.search.focus();
        }
      });
    },
    updateConfirmCB(input) {
      this.$emit('update:model-value', input.target.value);
      if (input.target.checked && this.hasDate) {
        this.$emit('update:dateValue', new Date().toString());
      }
    },
    update(input) {
      this.test(false);
      if (this.type === 'dropdown') {
        this.$emit('update:model-value', input);
      } else if (this.type === 'yesno' || this.type === 'yesno2') {
        if (!this.confirm) {
          this.updateConfirmCB(input);
        } else {
          this.$store.state.confirm.toggle({
            text: this.confirm.trim().replace(/\s\s+/g, ' '),
            cb: (confirmed) => {
              if (confirmed) {
                this.updateConfirmCB(input);
              }
            },
          });
        }
      } else if (this.type === 'file' || this.type === 'addFile') {
        this.$emit('update:model-value', `${this.localFiles.length}`);
      } else {
        this.$emit('update:model-value', input.target.value);
      }
      this.$emit('changed');
    },
    test(show = true) {
      this.showValid = show;
      let required = true;
      // fix by required validation thingy
      if (this.type === 'radio2') {
        this.valid = this.modelValue != null;
      }
      if (this.validation && this.validationToggle) {
        for (let i = 0; i < this.validation.length; i += 1) {
          if (this.validation[i] === 'notrequired') {
            required = false;
          }
          if (this.validation[i] === 'email') {
            this.tooltipText = 'Dit is geen e-mailadres.';
            const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/g;
            if (!re.test(this.modelValue)) {
              this.valid = false;
              break;
            }
          }
          if (this.validation[i] === 'yes') {
            if (`${this.modelValue}` !== 'Yes') {
              this.valid = false;
              break;
            }
          }
          if (this.validation[i] === 'bsn') {
            this.tooltipText = 'Foutief BSN, geef aan belastingplichting in het buitenland om TIN nummer in te vullen.';
            if (`${this.modelValue}`.length !== 9 && `${this.modelValue}`.length !== 8) {
              this.valid = false;
              break;
            }
            let checksum = 0;
            for (let j = 0; j < `${this.modelValue}`.length - 1; j += 1) {
              checksum += Number(`${this.modelValue}`[j]) * (`${this.modelValue}`.length - j);
            }
            checksum -= Number(`${this.modelValue}`[`${this.modelValue}`.length - 1]);

            if (checksum % 11 !== 0) {
              this.valid = false;
              break;
            }
          }
          if (this.validation[i] === 'iban' && this.modelValue) {
            this.tooltipText = 'Dit is geen correct IBAN-nummer.';

            let sum = String(this.modelValue);
            sum = sum.replace(/ /gi, '');
            sum = sum.replace(' ', '');
            if (sum.length < 15) {
              this.valid = false;
              break;
            }

            sum = sum.slice(4) + sum.slice(0, 4);
            const letters = {
              a: 10,
              b: 11,
              c: 12,
              d: 13,
              e: 14,
              f: 15,
              g: 16,
              h: 17,
              i: 18,
              j: 19,
              k: 20,
              l: 21,
              m: 22,
              n: 23,
              o: 24,
              p: 25,
              q: 26,
              r: 27,
              s: 28,
              t: 29,
              u: 30,
              v: 31,
              w: 32,
              x: 33,
              y: 34,
              z: 35,
            };
            // eslint-disable-next-line
            for (const [key, value] of Object.entries(letters)) {
              sum = sum.replace(new RegExp(key, 'gi'), value);
            }

            // eslint-disable-next-line
            function iso7064Mod97_10(iban) {
              let remainder = iban;
              let block;

              while (remainder.length > 2) {
                block = remainder.slice(0, 9);
                remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
              }
              return parseInt(remainder, 10) % 97;
            }

            sum = iso7064Mod97_10(sum);

            if (sum % 97 !== 1) {
              this.valid = false;
              break;
            }
          }
          if (this.validation[i] === 'min') {
            if (this.type === 'date') {
              if (new Date(this.modelValue) < this.minDatetime) {
                this.tooltipText = `Deze datum moet na ${this.minDatetime.toLocaleDateString()} liggen.`;
                this.valid = false;
                break;
              }
            } else {
              this.tooltipText = `Dit veld moet minimale waarde van ${this.formatPrice(
                this.min,
                true,
              )} hebben.`;
              if (this.modelValue < this.min) {
                this.valid = false;
                break;
              }
            }
          }
          if (this.validation[i] === 'max') {
            if (this.type === 'date') {
              if (new Date(this.modelValue) > this.maxDatetime) {
                this.tooltipText = `Deze datum moet voor ${this.maxDatetime.toLocaleDateString()} liggen.`;
                this.valid = false;
                break;
              }
            } else {
              this.tooltipText = `Dit veld moet een lagere waarde dan ${this.formatPrice(
                this.max,
                true,
              )} hebben.`;
              if (this.modelValue > this.max) {
                this.valid = false;
                break;
              }
            }
          }
          if (this.validation[i] === 'files') {
            required = false;
            if (this.localFiles.length === 0) {
              this.tooltipText = 'Dit veld moet minimaal 1 bestand hebben.';
              this.valid = false;
              break;
            }
          }
          if (this.validation[i] === 'phone') {
            const re = /^[+\\(\\)\d\-\\/\\*\\.\s]*$/;
            if (
              re.test(this.modelValue) !== true
              && !(
                (this.modelValue === '' || this.modelValue === undefined)
                && this.validation.includes('notrequired')
              )
            ) {
              this.tooltipText = 'Dit is geen geldig telefoonnummer.';
              this.valid = false;
              break;
            }
          }
          this.valid = true;
        }
      }

      if (required) {
        if (
          !this.modelValue
          || (
            !Number.isNaN(Number(this.modelValue))
            && Number(this.modelValue) < 1
          )
        ) {
          this.tooltipText = 'Dit veld is verplicht.';
          this.valid = false;
        } else if (!this.validation) {
          this.valid = true;
        }
      }

      // eslint-disable-next-line
      this.$store.state.intake[this.id] = this.valid;
    },
    uploadFiles(files) {
      const newprefix = this.prefix ? `${this.prefix}-` : '';
      let intake = this.getQueryVariable('intake');
      if (this.intakeId) {
        intake = this.intakeId;
      }
      this.sdk.addFileIntake(
        newprefix,
        intake,
        files,
        (response) => {
          if (response.status === 200) {
            if (this.level === 3) {
              this.$parent.$parent.$parent.files = response.data.files || [];
            } else {
              this.$parent.$parent.files = response.data.files || [];
            }
            this.update();
            this.cb();
            this.valid = true;
            if (Number(this.$store.state.role) < 7
              && newprefix.includes('overdrachten-')
              && newprefix.includes('-ondertekend')) {
              this.$store.state.confirm.toggle({
                alert: true,
                text: `
                Bedankt voor het uploaden van het ondertekende overdrachtsformulier.
                Wij gaan hiermee aan de slag en zullen contact met u opnemen als hiervoor extra
                informatie en/of documentatie nodig is.
                <br><br>Zonder tegenbericht kunt u ervan uitgaan dat wij het kapitaal hebben opgevraagd
                bij de partij in kwestie. Onder normale omstandigheden wordt het kapitaal in 15
                werkdagen overgedragen na expiratiedatum of uitvraag van het kapitaal door ons.
                <br><br>Zodra het kapitaal is ontvangen, zullen wij u hierover informeren.
                `,
                cb: () => {},
              });
            }
          } else {
            this.valid = false;
            this.tooltip = true;
            this.tooltipText = 'Fout met uploaden.';
            if (this.type === 'addFile') {
              // eslint-disable-next-line
              window.alert('Er is een fout opgetreden bij het uploaden van het bestand, mogelijk door het type bestand of de grootte van het bestand.');
            }
          }
        },
      );
    },
    remove(file) {
      this.$store.state.confirm.toggle({
        text: 'Wilt u dit bestand verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            let intake = this.getQueryVariable('intake');
            if (this.intakeId) {
              intake = this.intakeId;
            }
            this.sdk.deleteIntakeFile(
              intake,
              file,
              (response) => {
                if (response.status === 200) {
                  if (this.level === 3) {
                    this.$parent.$parent.$parent.files = remove(
                      this.$parent.$parent.$parent.files,
                      (o) => o.path !== file,
                    );
                  } else {
                    this.$parent.$parent.files = remove(
                      this.$parent.$parent.files,
                      (o) => o.path !== file,
                    );
                  }
                  this.update();
                  this.cb();
                } else {
                  // error
                }
              },
            );
          }
        },
      });
    },
    download(file) {
      let intake = this.getQueryVariable('intake');
      if (this.intakeId) {
        intake = this.intakeId;
      }
      this.sdk.getIntakeFile(intake, file);
    },
    focused() {
      return this.focus;
    },
    toggleTooltip() {
      this.tooltip = !this.tooltip;
    },
    isMobile() {
      if (
        window.matchMedia('(max-width: 800px)').matches
        && /Mobi/.test(navigator.userAgent)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.inputbox {
  position: relative;
  margin: 2px;

  &::after {
    content: "";
    display: block;
    clear: both;
  }
  &.error {
    input:hover, input:focus {
      background-color: rgba(#d9534f, 0.1);
    }
    label,
    .label,
    .info,
    .custom-dropdown .label {
      color: #d9534f;
    }
  }
  &.error.yesno,
  &.error.radio2 {
    .input-info {
      display: none;
    }
  }

  &.focus {
    input {
      background-color: rgba($color-highlight, 0.2);
      &:disabled {
        background-color: initial;
      }
    }
  }

  input, .input {
    padding: 30px 20px 10px 20px;
    color: darken($color-highlight, 5%);
    background-color: #f7f8fa;
    border-radius: $br;
    width: 100%;
    font-size: inherit;
    line-height: inherit;
    font-family: inherit;
    box-sizing: border-box;
    border: none;
    outline: none;
    &::placeholder, &:disabled {
      color: rgba(#000, 0.5);
    }
  }

  .input-info {
    position: absolute;
    top: 10px;
    right: 15px;
    color: #d9534f;
    cursor: pointer;
    z-index: 1;
  }

  .input-tooltip {
    position: absolute;
    left: 0px;
    right: 0px;
    text-align: left;
    background-color: #f5d4d3;
    padding: 10px;
    border-radius: 2px;
    z-index: 97;
    bottom: 71px;
    color: #d9534f;
    pointer-events: none;
  }

  .label {
    position: absolute;
    top: 13px;
    left: 20px;
    pointer-events: none;
    max-width: 80%;
  }
}

.file {
  input[type="file"] {
    display: none;
  }
  .file-dropzone {
    width: 100%;
    height: 65px;
    background-color: #e9ecf2;
    margin-top: 2px;
    border: 2px dashed rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    transition: height 0.15s;
    padding: 0 30px;
    &.expanded {
      height: 100px;
    }
    svg {
      font-size: 15px;
      color: rgba(0, 0, 0, 0.5);
    }
    span {
      font-size: 15px;
      text-align: center;
      color: rgba(0, 0, 0, 0.5);
      padding: 0 20px;
      line-height: 25px;
    }
    &.error {
      border: 2px dashed #d9534f;
      span {
        color: #d9534f;
      }
      svg {
        color: #d9534f;
      }
    }
  }
  .file-row {
    padding: 10px 20px;
    background-color: #f7f8fa;
    &:hover {
      background-color: rgba($color-highlight, 0.2);
    }
    .file-button {
      float: right;
      cursor: pointer;
      color: rgba(0, 0, 0, .5);
      margin-left: 20px;
      &:hover {
        text-decoration: none;
        color: #000;
      }
    }
  }
}

.slider {
  padding: 10px 20px;
  position: relative;
  background-color: #f7f8fa;
  transition: background-color 0.2s;
  &:hover {
    background-color: darken(#f7f8fa, 5%);
  }
  .min,
  .max {
    position: absolute;
    top: 40px;
  }
  .max {
    right: 20px;
  }
  .min {
    left: 20px;
  }
  .slider-label {
    text-align: left;
    position: absolute;
    top: 13px;
    left: 20px;
    .icon {
      color: rgba(0, 0, 0, 0.15);
    }
    input[type="number"] {
      border: 1px solid #ccc;
      padding: 2px 7px;
      border-radius: 2px;
      background: #fff;
      margin: 0 2px;
      font-weight: 600;
      width: 60px;
      height: initial;
      line-height: initial;
      color: #000;
      display: inline-block;
      -moz-appearance: textfield;
      text-align: center;
    }
  }
  .slider-value {
    display: inline-block;
  }
  .slider-tooltip {
    position: absolute;
    top: 20px;
    font-size: 10px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 5px 10px;
    border-radius: 2px;
    margin-top: -20px;
    margin-left: -20px;
  }

  input[type="range"]::-webkit-slider-runnable-track {
    height: 2px;
    background: $color-highlight;
    border: none;
    outline: none;
    border-radius: 2px;
  }
  input[type="range"]::-webkit-slider-thumb {
    border: 4px solid #fdfdfd;
    width: 20px;
    height: 20px;
    background: $color-highlight2;
    border-radius: 50%;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -9px;
  }

  input[type="range"] {
    padding: 0;
    appearance: none;
    padding-left: 50px;
    padding-right: 70px;
    margin-top: 30px;
    margin-bottom: 0;
    outline: none;
    background-color: transparent;
    box-shadow: none;
    height: 18px;
    &::-moz-range-track {
      height: 4px;
      background: $color-highlight;
      border: none;
      outline: none;
      border-radius: 2px;
    }
    &::-moz-range-thumb {
      width: 14px;
      height: 14px;
      background: $color-highlight2;
      cursor: pointer;
      border: 4px solid #fdfdfd;
      border-radius: 50%;
      outline: none;
    }
    &::-moz-focus-outer {
      border: 0;
    }
  }

  input[type="range"]::-ms-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  input[type="range"]::-ms-fill-lower,
  input[type="range"]::-ms-fill-upper {
    background: $color-highlight;
    height: 3px;
    border: 3px solid #fdfdfd;
  }

  input[type="range"]::-ms-thumb {
    height: 16px;
    width: 16px;
    border-radius: 50%;
    cursor: pointer;
    transform: scale(1) !important;
    margin-top: 0px;
    border: 4px solid #fdfdfd;
  }
}

.dropdown.listup
.custom-dropdown
.list-container {
  bottom: 100%;
}

.dropdown {
  input.dropdown-display {
    cursor: pointer;
  }
  ul, li {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  @media #{$desktop} {
    ul {
      width: 240px;
    }
  }
  select {
    appearance: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: transparent;
    color: transparent;
    box-shadow: none;
    option {
      color: initial;
    }
  }
  .bg {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(#000, 0.4);
    z-index: 98;
  }
  .list-container {
    background-color: #fff;
    line-height: 14px;
    margin: 0 10px;
    border-radius: $br;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 99;
    @media #{$mobile} {
      position: fixed;
      top: 10px;
    }
    .list {
      max-height: 220px;
      overflow: auto;
    }
    .search {
      input {
        border-bottom: 1px solid #dcdcdc;
        padding: 10px 20px;
        font-size: 1em;
        background-color: #fff;
        border-radius: 0;
      }
    }
    .cancel {
      background-color: #eee;
      padding: 10px 20px;
      border-top: 1px solid #dcdcdc;
      cursor: pointer;
      &:hover,
      &:focus {
        background-color: #eee;
        color: darken($color-highlight, 5%);
        outline: none;
      }
    }
    li {
      cursor: pointer;
      padding: 10px 20px;
      border-top: 1px solid #dcdcdc;
      transition: background-color 0.1s;
      &:first-child {
        border-top: none;
      }
      &:hover,
      &:focus {
        background-color: rgba($color-highlight, 0.2);
        outline: none;
      }
    }
  }
}

.yesno {
  padding: 13px 20px 12px 20px;
  background-color: #f7f8fa;
  border-radius: $br;
  &.small {
    padding: 30px 20px 10px 20px;
  }

  @media #{$mobile} {
    .label {
      position: relative;
      top: 0;
      left: 0;
      margin-bottom: 5px;
    }
  }

  input[type="checkbox"],
  input[type="radio"] {
    display: none;
  }
  label,
  .time {
    cursor: pointer;
    color: initial;
    @media #{$mobile} {
      float: left;
      padding-right: 10px;
    }
    @media #{$desktop} {
      float: right;
      padding-left: 10px;
    }
    &:focus {
      svg {
        color: $color-highlight;
      }
    }
  }
  input[type="checkbox"]:checked + label,
  input[type="radio"]:checked + label {
    color: darken($color-highlight, 5%);
  }
  &.align-left {
    label {
      float: left;
      padding-left: 0px;
      padding-right: 10px;
    }
  }
}

.radio,
.radio2,
.checkbox,
.checkbox2,
.yesno2 {

  text-align: left;
  overflow: auto;
  background-color: #f7f8fa;
  border-radius: $br;

  &.txtright {
    label {
      text-align: right;
    }
  }
  &.txtcenter {
    label {
      text-align: center;
    }
  }
  input[type="checkbox"],
  input[type="radio"] {
    display: none;
  }
  input[type="checkbox"] + label,
  input[type="radio"] + label {
    position: relative;
    padding: 12px 16px;
    box-sizing: border-box;
    width: 100%;
    float: left;
    cursor: pointer;
    &:first-of-type {
      margin-left: 0;
    }
    svg {
      margin-right: 10px;
    }
    &:focus {
      outline: none;
      svg {
        color: $color-highlight;
      }
    }
  }
  input[type="checkbox"]:checked + label,
  input[type="radio"]:checked + label {
    color: darken($color-highlight, 5%);
    padding-left: 16px;
    &:first-letter {
      text-transform: uppercase;
    }
  }
}
</style>
